import axios from 'axios'
import router from '../../router'

const state = {
  myFavorite: [],
  myRegEstate: [],
  myBuyDocument: [],
  myQnaList: [],
  myQnaTran: '',
  myFavoriteTran: '',
  myCheckFavorite: '',
  myWithdrawTran: '',
  memberDelRtn: ''
}

const getters = {
  getMyFavorite (state) {
    return state.myFavorite
  },
  getMyRegEstate (state) {
    return state.myRegEstate
  },
  getMyBuyDocument (state) {
    return state.myBuyDocument
  },
  getMyQnaList (state) {
    return state.myQnaList
  },
  getMyQnaTran (state) {
    return state.myQnaTran
  },
  getMyFavoriteTran (state) {
    return state.myFavoriteTran
  },
  getMyCheckFavorite (state) {
    return state.myCheckFavorite
  },
  getMyWithdraw (state) {
    return state.myWithdrawTran
  },
  getMemberDelRtn (state) {
    return state.memberDelRtn
  }
}

const mutations = {
  setMyFavorite (state, payload) {
    state.myFavorite = payload
  },
  setMyRegEstate (state, payload) {
    state.myRegEstate = payload
  },
  setMyBuyDocument (state, payload) {
    state.myBuyDocument = payload
  },
  setMyQnaList (state, payload) {
    state.myQnaList = payload
  },
  setMyQnaTran (state, payload) {
    state.myQnaTran = payload
  },
  setMyFavoriteTran (state, payload) {
    state.myFavoriteTran = payload
  },
  setMyCheckFavorite (state, payload) {
    state.myCheckFavorite = payload
  },
  setMyWithdraw (state, payload) {
    state.myWithdrawTran = payload
  },
  setMemberDelRtn (state, payload) {
    state.memberDelRtn = payload
  }
}

const actions = {
  apiMyFavorite (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/member/mypage/getFavoriteEstate', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setMyFavorite', response.data)
        })
        .catch((error) => {
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
          // alert(error.response.data.message)
        })
    }
  },
  apiMyRegEstate (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/member/mypage/getMyRegEstate', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setMyRegEstate', response.data)
        })
        .catch((error) => {
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
          // alert(error.response.data.message)
        })
    }
  },
  apiMyBuyDocument (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/member/mypage/getBuyDocument', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setMyBuyDocument', response.data)
        })
        .catch((error) => {
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
          // alert(error.response.data.message)
        })
    }
  },
  apiMyQnaList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/member/mypage/getMyQnaList', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setMyQnaList', response.data)
        })
        .catch((error) => {
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
          // alert(error.response.data.message)
        })
    }
  },
  apiTranMyQna (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/member/mypage/tranMyQna', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setMyQnaTran', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              // sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  },
  apiTranMyFavorite (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/member/mypage/tranMyFavorite', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setMyFavoriteTran', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              // sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  },
  apiTranMemberWithdraw (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/member/mypage/deleteMember', payload)
          .then((response) => {
            // console.log('apiTran = ' + response.data)
            context.commit('setMyWithdraw', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              // sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  },
  apiCheckFavorite (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/member/mypage/getEstateFavoriteCheck', payload)
          .then((response) => {
            // console.log(response.data)
            context.commit('setMyCheckFavorite', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 403) {
              // sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.push('/')
            }
            reject(error.response.data.message)
            // alert(error.response.data.message)
          })
      })
    }
  },
  apiDeleteEstate (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/member/mypage/deleteEstateData', payload)
          .then((response) => {
            // console.log('deleteTran = ' + response.data)
            context.commit('setMemberDelRtn', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/Login')
            } else {
              alert('삭제가 정상적으로 처리되지 않았습니다.')
            }
            // alert(error.response.data.message)
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/mypage.js